import * as React from 'react'
import './index.scss'
import { OrderCardProps } from './types'
import { Icon } from '@petz/ds-icon'
import Lottie from 'lottie-react'
import { Skeleton } from '@petz/ds-skeleton'
import { SegmentContext } from '../../hooks/SegmentContext'

function handleDescription(status: string) {
  switch (status) {
    case 'Retirada Liberada':
      return 'Vem retirar sua compra na loja escolhida.'
    case 'Em Transito':
      return 'Estamos indo até você.'
    case 'Pedido Ativo':
      return 'Em breve te passamos mais atualizações.'
    case 'Pedido Entregue':
      return 'Agora é só aproveitar suas compras.'
    default:
      return 'Em breve te passamos mais atualizações.'
  }
}

export const OrderCard: React.FC<OrderCardProps> = ({ title, status, icon, orderNumber, orderId }: OrderCardProps) => {
  const { segmentTrack } = React.useContext(SegmentContext)
  const [animationData, setAnimationData] = React.useState(null)
  const permittedStatus = ['Retirada Liberada', 'Em Transito', 'Pedido Ativo', 'Pedido Entregue']
  const treatedTitle = permittedStatus.includes(status) ? title : 'Pedido realizado'
  const treatedIcon = permittedStatus.includes(status) ? icon : 'https://static-file.petz.com.br/platforms/img/product/superapp/lottie/Pedido_Ativo.json'

  React.useEffect(() => {
    const fetchLottieAnimation = async () => {
      try {
        const response = await fetch(treatedIcon)
        if (!response.ok) {
          throw new Error(`Erro ao carregar a animação: ${response.statusText}`)
        }
        const data = await response.json()
        setAnimationData(data)
      } catch (error) {
        console.error('Erro ao carregar o Lottie:', error)
      }
    }

    if (treatedIcon) {
      fetchLottieAnimation()
    }
  }, [treatedIcon])

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault()
    segmentTrack('Help Option Clicked', {
      widget: true,
      alt_text: 'ajuda-alt',
      help_section: 'Acompanhar pedido',
      help_subsection: 'Acompanhar pedido',
      button_name: title,
      link_url: `/petz-pedidos/${orderId}`,
    })

    window.location.href = `/petz-pedidos/${orderId}`
  }

  return (
    <a className="order-card-container" href={`/petz-pedidos/${orderId}`} data-testid="order-card" onClick={handleClick}>
      <div className="order-card-icon-container">
        {animationData ? <Lottie animationData={animationData} loop autoplay style={{ width: 64, height: 64 }} /> : <Skeleton height={64} width={64} />}
      </div>
      <div className="order-card-text-container">
        <p className="order-id">{'Pedido ' + (orderNumber ?? 'sem número')}</p>
        <p className="order-status">{treatedTitle}</p>
        <p className="order-description">{handleDescription(status)}</p>
      </div>
      <div className="order-card-arrow-container">
        <Icon name="arrow-right" variant="line" size="md" />
      </div>
    </a>
  )
}
